var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"periodoCiclo"}},[_c('date-picker',{attrs:{"type":"month","placeholder":"Seleccionar mes"},model:{value:(_vm.periodo),callback:function ($$v) {_vm.periodo=$$v},expression:"periodo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }